import {FormulaClause} from 'common/report/insights/models/clause';
import type {ProdTrackingEvent} from 'common/report/insights/tracking';

export interface Formula {
  label?: string;
  value: string;
}
export interface FormulaTrackingInfo {
  event: ProdTrackingEvent;
  formula: Formula;
}

// TODO(jakub), remove this; Conversion while we get out of clause-land
export function formulaClauseToFormula(clause: FormulaClause): Formula {
  return {...clause.attrs} as Formula;
}

export function formulaToFormulaClause(formula: Formula): FormulaClause {
  return new FormulaClause(formula);
}
